import { UserProfile } from 'fitbeat.gym-core';
import { BaseEquipment } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { TranslateProp } from '../../common-types';
import { toggleStrengthAssessmentModal } from '../../ui/redux/uiActions';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  userProfile: UserProfile;
  t: TranslateProp;
}

interface IDispatchProps {
  strengthAssessmentSliderCardPressed(): void;
}

const StrengthAssessmentSliderCard: FunctionComponent<IProps & IDispatchProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    strengthAssessmentSliderCardPressed,
    userProfile,
    t,
  },
) => {
  const PTGroupImageHeight = 265;
  const PTGroupImageWidth = 278;
  const userHasNotCompletedStrengthAssessment = !userProfile.strengthRatioForMuscleGroups;
  const userHasBenchBandsSetAsDefaultEquipment = BaseEquipment.isHomeBenchBandsEquipmentSelection(
    userProfile.defaultEquipment,
  );
  const shouldShowSetupSmartHomeGym = userHasNotCompletedStrengthAssessment && userHasBenchBandsSetAsDefaultEquipment;
  return (
    <HorizontalScrollerCard
      style={workoutSliderCardStyle.container}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
      onPress={strengthAssessmentSliderCardPressed}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={PTGroupImageHeight}
        imageWidth={PTGroupImageWidth}
        header={shouldShowSetupSmartHomeGym ? t('setupSmartHomeGym') : t('startStrengthAssessment')}
        image={require('../../assets/images/bench-press-with-uni-bands.png')}
      />
    </HorizontalScrollerCard>
  );
};

const mapDispatchToProps = (dispatch): IDispatchProps => ({
  strengthAssessmentSliderCardPressed: () => dispatch(toggleStrengthAssessmentModal(true)),
});

export default connect(null, mapDispatchToProps)(StrengthAssessmentSliderCard);
